import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@/components/theme-provider";
import { AuthProvider } from "@/context/auth-context";
import { App } from "./App";
import "./styles/globals.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Treat data as fresh for 5 min — most of what we fetch (agents,
      // companies, catalogues) rarely changes mid-session. Cuts the
      // refetch-on-every-nav churn that made /dashboard and tenant
      // pages feel slow.
      staleTime: 5 * 60_000,
      // Keep cached data around for 30 min after the last subscriber
      // unmounts so back/forward navigation hits cache instead of network.
      gcTime: 30 * 60_000,
      // Don't refire every query when the user tabs back to the window.
      // Mutations already invalidate the specific keys that matter.
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
